import { Swiper } from "swiper";
import { Autoplay } from "swiper/modules";

class CaseStudySlider {
  constructor() {
    this.init();
  }

  init = () => {
    const slider = new Swiper(".js-case-study-slider", {
      modules: [Autoplay],
      spaceBetween: 12,
      slidesPerView: 1.4,
      centeredSlides: true,
      speed: 1200,
      loop: true,
      allowTouchMove: false,
      slideToClickedSlide: true,
      /*autoplay: {
        delay: 8000,
      },*/
      breakpoints: {
        520: {
          spaceBetween: 30,
          slidesPerView: 1.2,
        },
      },
    });
  };
}

new CaseStudySlider();
